import { render, staticRenderFns } from "./SeparatorConfig.vue?vue&type=template&id=57857b65&scoped=true"
import script from "./SeparatorConfig.vue?vue&type=script&lang=js"
export * from "./SeparatorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57857b65",
  null
  
)

export default component.exports